import { messaging, getToken } from './firebase';
import api from './api';

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export async function registerFCMToken() {
  try {
    console.log('🔔 [FCM] Iniciando registro de token...');
    
    // Check if messaging is available
    if (!messaging) {
      console.error('❌ [FCM] Firebase Messaging no disponible');
      return { success: false, error: 'Messaging not available' };
    }

    // Check notification permission
    const permission = Notification.permission;
    console.log('🔔 [FCM] Permission actual:', permission);
    
    if (permission !== 'granted') {
      console.warn('⚠️  [FCM] Permisos no concedidos');
      return { success: false, error: 'Permission not granted' };
    }

    // Get service worker registration
    console.log('🔔 [FCM] Buscando Service Worker...');
    const registration = await navigator.serviceWorker.ready;
    console.log('✅ [FCM] Service Worker encontrado:', registration.scope);

    // Get FCM token
    console.log('🔔 [FCM] Solicitando token de Firebase...');
    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    if (!token) {
      console.error('❌ [FCM] No se pudo obtener el token');
      return { success: false, error: 'No token received' };
    }

    console.log('✅ [FCM] Token obtenido:', token.substring(0, 40) + '...');

    // Send token to backend
    console.log('📤 [FCM] Enviando token al backend...');
    const response = await api.post('/api/fcm/token', { token });
    console.log('✅ [FCM] Token guardado en backend:', response.data);

    return { success: true, token };
  } catch (error) {
    console.error('❌ [FCM] Error en registro:', error);
    console.error('   Tipo:', error.name);
    console.error('   Mensaje:', error.message);
    console.error('   Stack:', error.stack);
    return { success: false, error: error.message };
  }
}
